/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberReference
 */
export interface MemberReference {
    /**
     * 
     * @type {string}
     * @memberof MemberReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MemberReference
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof MemberReference
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof MemberReference
     */
    email: string;
}

/**
 * Check if a given object implements the MemberReference interface.
 */
export function instanceOfMemberReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function MemberReferenceFromJSON(json: any): MemberReference {
    return MemberReferenceFromJSONTyped(json, false);
}

export function MemberReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
    };
}

export function MemberReferenceToJSON(value?: MemberReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
    };
}

